<template>
  <component class="text-medium" :is="comment ? 'with-gallery' : 'div'">
    <div>
      <activity-header
        :theme-color="themeColor"
        :activity="activity"
        :action-label="actionLabel"
        :created-at="activity.createdAt"
        :show-team-org-name="showTeamOrgName"
        :award-context="awardContext"
        :team-id="teamId"
        @awarded="$emit('awarded')"
        @reacted="$emit('reacted')"
      />
    </div>
    <div class="meta">
      <activity-entity :project="project" :goal="goal" :activity="activity" v-if="showEntityInfo" />
      <slot></slot>
      <height-limiter max-height="77" :bg-type="themeColor" v-if="comment">
        <div class="comment" v-html="formattedComment"></div>
      </height-limiter>
      <reactions-list
        class="reactions-list mt-3"
        :event="activity"
        @reacted="$emit('reacted')"
        v-if="areReactionsAvailable"
      />
    </div>
  </component>
</template>

<script>
import ReactionsList from '@/components/reactions/ReactionsList'
import * as R from 'ramda'
import ActivityEntity from '@/components/activity/ActivityEntity'
import ActivityHeader from '@/components/activity/ActivityHeader'
import HeightLimiter from '@/components/HeightLimiter'
import WithGallery from '@/components/WithGallery'
import formatFreeText from '@/utils/formatFreeText'

/**
 * This provides a generic view of activity
 * It show header(with ability to react/award), entity (goal/kr/initiative) title, comment, reactions
 *
 * slots:
 * default: slot gets rendered after entity title
 *
 * @emits
 * - reacted
 * - awarded
 */
export default {
  name: 'ActivityView',
  props: [
    'activity',
    'showTeamOrgName',
    'themeColor',
    'showEntityInfo',
    'comment',
    'awardContext',
    'createdAt',
    'actionLabel',
    'goal',
    'project'
  ],
  components: {
    WithGallery,
    ActivityHeader,
    ActivityEntity,
    HeightLimiter,
    ReactionsList
  },
  data() {
    return {}
  },
  computed: {
    formattedComment() {
      return formatFreeText(this.activity.organizationId, this.activity.comment)
    },
    areReactionsAvailable() {
      return !R.isEmpty(this.activity.reactionSummary)
    },
    teamId() {
      return (this.goal || this.project)?.teamId
    }
  },
  methods: {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.meta {
  margin-left: 38px;
}

.comment {
  &:not(:hover)::-webkit-scrollbar-track,
  &:not(:hover)::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
}
</style>
